import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';

import Button from '../../../core/components/Button.tsx';
import { withIcon } from '../../../core/components/Icon.tsx';
import InboxVisualImage from '/images/inbox_assistant_marketing.avif';
import VoiceVisualImage from '/images/voice_assistant_marketing.avif';

const ExternalLinkIcon = withIcon(faArrowUpRightFromSquare);

export type AssistantMarketingKind = 'inboxAgent' | 'voiceAgent';

interface AssistantMarketingBannerProps {
    kind: AssistantMarketingKind;
    tag: string;
    title: React.ReactNode;
    description: string;
    ctaLabel: string;
}

const VISUAL_BY_KIND: Record<AssistantMarketingKind, string> = {
    inboxAgent: InboxVisualImage,
    voiceAgent: VoiceVisualImage,
};

const AssistantMarketingBanner = ({ kind, tag, title, description, ctaLabel }: AssistantMarketingBannerProps) => (
    <div className="flex flex-col items-center gap-6 overflow-hidden rounded-lg border border-line-weak bg-surface-brand-weak px-8 py-14 md:flex-row md:justify-between">
        <div className="flex min-w-0 flex-col items-start gap-3">
            <span className="rounded border border-solid border-line-brand-weak bg-surface-white px-2 py-1 text-xs font-medium text-content-brand-default">
                {tag}
            </span>
            <h3 className="m-0 text-2xl font-semibold text-content-strong">{title}</h3>
            <p className="m-0 max-w-md text-sm text-content-strong">{description}</p>
            <Button className="flex items-center gap-2">
                {ctaLabel}
                <ExternalLinkIcon />
            </Button>
        </div>
        <img src={VISUAL_BY_KIND[kind]} alt="" className="h-auto w-[clamp(300px,32vw,500px)] flex-none" />
    </div>
);

export default AssistantMarketingBanner;
